<template>
  <controller-frame title="Scenes" v-if="mode === 'scenes'">
    <div class="Scenes">
      <div>
        <a class="btn" @click="selectBackgroundImage">背景を変更</a>
        <a class="btn" @click="selectPanelImage">パネル画像を変更</a>
        <a class="btn" @click="selectImageObject">画像を盤面に追加</a>
        <a class="btn" @click="selectBGM01">BGM01を変更</a>
        <a class="btn" @click="selectBGM02">BGM02を変更</a>
        <a class="btn" @click="selectSE01">SE01を変更</a>
      </div>
      <div class="select">
        <h3>立体表示</h3>
        <select @change="setTableMode" :value="room.tableMode">
          <option value="2d">2d</option>
          <option value="3d">3d</option>
        </select>
      </div>
      <div class="select">
        <h3>パネル比率</h3>
        <select @change="setTableRatio" :value="room.tableRatio">
          <option value="a5">A5</option>
          <option value="1:1">1:1</option>
          <option value="4:3">4:3</option>
          <option value="16:9">16:9 - default</option>
        </select>
      </div>
      <div class="scene-control">
        <a class="btn" @click="add()">新規シーン作成</a>
        <p class="search"><span>検索:</span><input type="text" v-model="inputText"></p>
      </div>
      <div class="scene-list">
        <div
          class="scene"
          :class="{ current: current === key }"
          v-for="({ key, name, room }, i) in scenes"
          :key="key"
        >
          <div class="head">
            <p><input type="text" :value="name" @change="(e) => updateName(key, e.target.value)"></p>
          </div>
          <div class="content">
            <div class="image">
              <div @click="restore(key)" class="bg" :style="{ backgroundImage: url(room.tableBackgroundImageKey) }">
                <div v-if="room.tableImageKey" class="bg" :style="{ backgroundImage: url(room.tableImageKey) }"></div>
              </div>
              <a class="btn-del" @click="remove(key, name)">削除</a>
            </div>
            <div class="actions">
              <div class="item">
                <a class="btn" @click="update(key)">現状を保存</a>
                <a class="btn" @click="duplicate(key)">複製する</a>
              </div>
            </div>
            <div class="move">
              <div class="item">
                <a class="btn" @click="index(key, scenes[i - 1])"><faicon icon="arrow-up" /></a>
                <a class="btn" @click="index(key, scenes[i + 1])"><faicon icon="arrow-down" /></a>
              </div>
            </div>
          </div>
          <div class="item col">
            <a class="btn" @click="restore(key)">BGMあり反映</a>
            <a class="btn" @click="restoreOnlyImage(key)">BGMなし反映</a>
          </div>
        </div>
      </div>
    </div>
  </controller-frame>
</template>

<script>
import controllerFrame from '../frames/controller'

export default {
  components: { 'controller-frame': controllerFrame },
  data() {
    return {
    }
  },
  computed: {
    mode() {
      return this.$store.getters['local/mode']
    },
    scenes() {
      const { inputText } = this
      if (inputText) {
        return this.$store.getters['scenes/filtered'](inputText)
      }
      return this.$store.getters['scenes/$sorted']
    },
    current() {
      return this.$store.getters['scenes/$currentKey']
    },
    room() {
      return this.$store.getters['room/state']
    },
    url() {
      return this.$store.getters['images/getBackgroundUrl']
    },
    inputText: {
      get() {
        return this.$store.getters['local/sceneSearchText']
      },
      set(value) {
        return this.$store.commit('local/set', { key: 'sceneSearchText', value })
      }
    },
  },
  methods: {
    update(key) {
      this.$store.dispatch('scenes/save', key)
    },
    updateName(key, name) {
      this.$store.dispatch('scenes/$update', { key, data: { name } })
    },
    add() {
      const name = this.inputText ? this.inputText + ' 名称未設定' : '名称未設定'
      const firstScene = this.$store.getters['scenes/$sorted'][0]
      const order = firstScene ? ~~firstScene.order - 1 : 0

      this.$store.dispatch('scenes/$create', { name, order })
    },
    index(key, target) {
      const index = this.$store.getters['scenes/$sorted'].indexOf(target)
      this.$store.dispatch('scenes/$index', { key, index })
    },
    duplicate(key) {
      this.$store.commit('scenes/$checkout', key)
      this.$store.dispatch('scenes/$duplicate')
    },
    remove(key, name) {
      if (confirm(`シーン「${name}」を削除します`)) {
        this.$store.dispatch('scenes/$remove', key)
      }
    },
    restore(key) {
      this.$store.commit('scenes/$checkout', key)
      this.$store.dispatch('scenes/restore', key)
    },
    restoreOnlyImage(key) {
      this.$store.commit('scenes/$checkout', key)
      this.$store.dispatch('scenes/restoreOnlyImage', key)
    },
    selectPanelImage() {
      this.$store.commit('selectors/open', {
        tags: ['scenes'],
        action: 'room/$set',
        context: { key: 'tableImageKey' }
      })
    },
    selectBackgroundImage() {
      this.$store.commit('selectors/open', {
        tags: ['scenes'],
        action: 'room/$set',
        context: { key: 'tableBackgroundImageKey' }
      })
    },
    selectImageObject() {
      this.$store.commit('selectors/open', {
        tags: ['objects'],
        action: 'imageObjectList/addImage'
      })
    },
    setTableMode(e) {
      const value = e.target.value
      this.$store.dispatch('room/$set', { key: 'tableMode', value })
    },
    setTableRatio(e) {
      const value = e.target.value
      this.$store.dispatch('room/$set', { key: 'tableRatio', value })
    },
    selectBGM01() {
      this.$store.commit('selectors/openSound', {
        tags: ['bgm'],
        action: 'room/$set',
        context: { key: 'bgm01SoundKey' }
      })
    },
    selectBGM02() {
      this.$store.commit('selectors/openSound', {
        tags: ['bgm2'],
        action: 'room/$set',
        context: { key: 'bgm02SoundKey' }
      })
    },
    selectSE01() {
      this.$store.commit('selectors/openSound', {
        tags: ['se'],
        action: 'room/$set',
        context: { key: 'se01SoundKey' }
      })
    }
  }
}
</script>

<style scoped>
.scene-control {
  margin-top: 5px;
}
.scene-control .search {
  margin: 10px 4px 0;
  position: relative;
}
.scene-control span {
  font-size: 10px;
  position: absolute;
  left: 6px;
  top: 50%;
  transform: scale(0.8) translateY(-55%);
  color: #888;
}
.scene-control .search input {
  padding-left: 30px;
}
.scene-list {
  padding: 10px;
}
.scene {
  margin-bottom: 7px;
  padding-bottom: 7px;
  border-bottom: 1px solid #222;
}
.scene.current {
  /* outline: 2px solid #fff; */
}
.scene .content {
  display: flex;
  position: relative;
}
.scene .head {
  padding-bottom: 5px;
}
.scene .head input[type=text] {
  border-radius: 0;
  border: none;
  background: rgba(0, 0, 0, 0.4);
}
.actions {
  margin-left: 7px;
  flex: 1;
}
.actions .item + .item {
  margin-top: 4px;
}
.item.col {
  display: flex;
}
.item.col > * {
  flex: 1;
}
.move {
  margin-left: 1px;
}
.bg {
  margin-bottom: 5px;
  width: 80px;
  height: 60px;
  background-size: cover;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.8);
  cursor: pointer;
}
.btn {
  padding: 7px 10px;
  display: block;
  text-align: center;
  background: rgba(0, 0, 0, 0.4);
  font-size: 10px;
}
.btn:hover {
  background: rgba(0, 0, 0, 0.2);
}
.btn-del {
  padding: 4px;
  border-radius: 4px;
  font-size: 10px;
  line-height: 1;
  position: absolute;
  top: 2px;
  left: 2px;
  background: #fff;
  display: block;
  color: #888;
}
.select {
  padding: 5px;
  display: flex;
}
.select h3 {
  margin-right: 5px;
  font-size: 12px;
}
</style>
